export var props = {
  visible: {
    type: Boolean,
    required: true,
    default: false
  },
  /** 是否展示关闭按钮 */
  showClose: {
    type: Boolean,
    default: false
  },
  /** 是否点击遮罩关闭 */
  closeOnClickModal: {
    type: Boolean,
    default: true
  },
  /** 是否将弹窗挂载到 body */
  appendToBody: {
    type: Boolean,
    default: false
  },
  /** 进入动画类名 */
  animateEnter: {
    type: String,
    default: ''
  },
  /** 离开动画类名 */
  animateLeave: {
    type: String,
    default: ''
  }
};